import { render, staticRenderFns } from "./OTActionsIndex.vue?vue&type=template&id=70edf3f4&scoped=true&lang=pug"
import script from "./OTActionsIndex.vue?vue&type=script&lang=js"
export * from "./OTActionsIndex.vue?vue&type=script&lang=js"
import style0 from "./OTActionsIndex.vue?vue&type=style&index=0&id=70edf3f4&prod&lang=scss&scoped=true"
import style1 from "./OTActionsIndex.vue?vue&type=style&index=1&id=70edf3f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70edf3f4",
  null
  
)

export default component.exports